
export class UpdatePupilDto {

    pupilId = 0;
    level: string = null;
    notePupilsList: string = null;
    schoolCareer: string = null;
    addToCourses: number[] = [];
    removeFromCourses: number[] = [];

    constructor(pupilId: number) {
        this.pupilId = pupilId;
    }
}
